import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Package } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function CustomerLogin({ setUser }) {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/customer/login", form);
      setUser(data);
      toast.success(`Welcome back, ${data.name}`);
      navigate("/customer");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 mb-2">
            <Package size={22} weight="bold" />
            <span className="text-lg font-black tracking-tight">Ronnex Customer Portal</span>
          </div>
          <p className="text-sm text-zinc-500">Welcome back. Sign in to manage your orders.</p>
        </div>
        <form onSubmit={submit} className="border border-zinc-200 bg-white p-6 space-y-4" data-testid="customer-login-form">
          <div>
            <Label className="text-[11px] uppercase tracking-widest text-zinc-500 font-semibold">Email</Label>
            <Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1" data-testid="login-email" />
          </div>
          <div>
            <Label className="text-[11px] uppercase tracking-widest text-zinc-500 font-semibold">Password</Label>
            <Input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-zinc-900 hover:bg-zinc-800 text-white" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
          <p className="text-xs text-center text-zinc-500">
            New here?{" "}
            <Link to="/customer/signup" className="text-zinc-900 font-semibold hover:underline">Create an account</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
